// 0: Female, 1: Male
import { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import chevronDownIcon from 'src/assets/chevron_down.svg';
import BottomSheetService from 'src/utils/BottomSheetService';
import './style.scoped.css';
import NationBottomSheet from './NationBottomSheet';
import Item from 'src/models/Item';

interface NationSelectorProps {
  value: string;
  onChange: (newNation: string) => void;
  isRequired?: boolean;
  nationList?: Item[];
}

const NationSelector = (props: NationSelectorProps) => {
  const { value, onChange, isRequired = false, nationList } = props;
  const { t } = useTranslation();

  const _handleClickInput = useCallback(() => {
    BottomSheetService.instance.current.open({
      visible: true,
      children: (
        <NationBottomSheet
          nationList={nationList}
          value={value}
          onChange={onChange}
        />
      ),
      showIndicator: false,
    });
  }, [nationList, onChange, value]);

  const _getNationName = useCallback(() => {
    if (!value) return null;
    return nationList.find((item) => item.id == value)?.name || null;
  }, [nationList, value]);

  return (
    <div>
      <div className="labelText mb-2">
        {t('nationality')}
        {isRequired ? <label className="bodyText text-error"> *</label> : ''}
      </div>
      <div
        className="inputContainer flex flex-row items-center"
        onClick={_handleClickInput}
      >
        <div className="inputValue flex-1">{_getNationName()}</div>
        <div>
          <img
            src={chevronDownIcon}
            className="w-4 h-2 object-cover"
            alt="dropdownIcon"
          />
        </div>
      </div>
    </div>
  );
};

export default NationSelector;
